import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import classNames from "classnames";

export const GBPSymbolIcon = ({
  size,
  type,
  className = "",
  onClick,
  refHandler,
  id,
  dataId,
}: ISVGIconProps) => {
  return (
    <svg
      className={classNames("svg-icon", {
        [`svg-icon__size-${size}`]: size,
        [`svg-icon__type-${type}`]: type,
        [className]: className,
      })}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      ref={refHandler}
      id={id}
      data-id={dataId ? `${dataId}-svg-icon` : ""}
    >
      <path
        d="M13.9978 3.27645C12.7063 2.92073 10.7424 2.76775 9.28601 3.71234C8.53203 4.20136 7.95158 4.96318 7.68536 6.04632C7.46499 6.94291 7.46398 8.03977 7.72439 9.36841H5.88068C5.5217 9.36841 5.23068 9.65942 5.23068 10.0184C5.23068 10.3774 5.5217 10.6684 5.88068 10.6684H8.02025C8.1233 11.188 8.19469 11.8379 8.07675 12.5459C7.91848 13.496 7.40966 14.6038 6.03838 15.6443C5.50092 16.0521 5.72518 16.9991 6.49127 16.9991H14.1193C14.4783 16.9991 14.7693 16.7081 14.7693 16.3491C14.7693 15.9902 14.4783 15.6991 14.1193 15.6991H7.90242C8.77965 14.7296 9.20059 13.7109 9.35908 12.7595C9.49084 11.9686 9.43734 11.2449 9.34179 10.6684H12.3538C12.7128 10.6684 13.0038 10.3774 13.0038 10.0184C13.0038 9.65942 12.7128 9.36841 12.3538 9.36841H9.05189C8.76304 8.04293 8.77338 7.0662 8.94779 6.35661C9.13701 5.58672 9.52386 5.10756 9.9934 4.80302C10.984 4.16051 12.4921 4.21013 13.6526 4.52978C13.9987 4.62511 14.3565 4.42182 14.4518 4.07572C14.5472 3.72963 14.3439 3.37178 13.9978 3.27645Z"
        fill="#888888"
      />
    </svg>
  );
};
